import React, {useState, useRef} from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import IconButton from "@mui/material/IconButton";
import "./NumberInputSpinner.scss";

const NumberInputSpinner = ({min, max, value, onChange, name}) => {
    //let [value, setValue] = useState(defaultValue);
    let [errorMessage, setErrorMessage] = useState("");
    const errorMessageText = useRef(null);
    const inputNumberRef = useRef(null);
    let titleText = "";

    if(name === 'limit') {
        titleText = "min value 1 and max value 100";
    }

    if(name === 'limitMisc') {
        titleText = "min value 1 and max value 24";
    }

    const increment = () => {
        // console.log("inc current val ", value);

        // If is not undefined
        if (!isNaN(value) && value < max) {
            value = value + 1;
            onChange(value);
        } else {
            // if max reached, then leave at current max value
            if (value !== max) {
                // Otherwise put a display default value. should we use 0?
                onChange(100);
            }
        }
        //onChange(value);
    }

    const decrement = () => {

        // console.log("dec current val ", value);

        // If it isn't undefined or its greater than 0
        if (!isNaN(value) && value > 1) {
            value = value - 1;
            onChange(value);
        } else {
            // Otherwise put a display default value. should we use 0?
            onChange(1);
        }

        //onChange(value);
    }

    /*
    const showErrorMessage = () => {
        let element = errorMessageText.current;

        console.log('element:', element.style.display);
        if (element.style.display === "none") {
            element.style.display = "block";
        } else {
            element.style.display = "none";
            setErrorMessage('');    // clear message
        }
    }
    */

    const validateValue = () => {

        if (isNaN(value)) {
            setErrorMessage(`Value (${value}) is not an integer number`);
        }

        if (Number.isInteger(value) && value > max) {
            setErrorMessage(`Value (${value}) greater than max: ${max}`);
        }

        if (Number.isInteger(value) && value < min) {
            setErrorMessage(`Value (${value}) less than min: ${min}`);
        }

        //showErrorMessage();
    }

    const valueUpdated = (e) => {
        
        if(name === 'limit') {
            let newVal = parseInt(e.target.value.replace(/^0/, 1));
            if(newVal > 100) {
                parseInt(e.target.value.replace([1-9]|[1-9][0-9]|[1-9][0-9][0-9], 100))
            }
            onChange(newVal);
        } else {
            let newVal = parseInt(e.target.value);
            onChange(newVal);
        }

        validateValue();
    }

    return (
        <div className="inputSpinnerContainer">
            
            <IconButton onClick={decrement} sx={{padding: 0}}>
                <RemoveCircleOutlineIcon fontSize="small"/>
            </IconButton>

            <input id="inputSpinnerValueId" title={titleText} ref={inputNumberRef} type="number" min={min} max={max} value={value} onInput={valueUpdated} className="inputSpinnerValue"/>
            <div id="errorMessage" ref={errorMessageText} className="inputSpinnerErrorMessage" style={{display: 'none'}}>{errorMessage}</div>

            <IconButton onClick={increment} sx={{padding: 0}}>
                <AddCircleOutlineIcon fontSize="small"/>
            </IconButton>

        </div>
    );
    

}

export default NumberInputSpinner;